import cloudinaryInstance from '../../lib/cloudinary'

cloudinaryInstance.responsive()
